import { render } from "./cpt-badge-option.vue?vue&type=template&id=4c5d0a0d"
import script from "./cpt-badge-option.vue?vue&type=script&lang=js"
export * from "./cpt-badge-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__